import { api } from '@/config/axiosConfig';
import {
  ListarCombosComProdutoResponse,
  ListarCombosResponse,
  ListarProdutosResponse,
  RecuperarComboResponse,
  RecuperarProdutoResponse,
} from './types/maketplace';
import { Produto } from '@/types/produto';
import { Combo } from '@/types/combo';

export const getDestaques = async () => {
  const response = await api.post('/Marketplace/BuscarDestaques');
  return response.data.dados;
};

export const getCategorias = async () => {
  const response = await api.post('/Marketplace/BuscarCategorias');
  return response.data.dados;
};

export const listarProdutos = async ({
  filtros,
}: {
  filtros?: string;
}): Promise<Array<Produto>> => {
  const form = new FormData();
  form.append('paginacao', JSON.parse('-1'));
  form.append('pagina', JSON.parse('1'));
  form.append('ordenacaoCampo', 'ordem');
  form.append('ordenacaoOrdem', 'asc');

  if (filtros) {
    form.append('filtros', filtros);
  }

  const response = await api.post<ListarProdutosResponse>(
    '/Marketplace/ListarProdutos',
    form,
  );
  return response.data.dados.lista;
};

export const recuperarProduto = async (
  termoBusca: string,
): Promise<Produto> => {
  const form = new FormData();
  form.append('slug', termoBusca);
  const response = await api.post<RecuperarProdutoResponse>(
    '/Marketplace/SelecionarProduto',
    form,
  );
  return response.data.modelo;
};

export const listarCombos = async ({
  filtros,
}: {
  filtros?: string;
}): Promise<Array<Combo>> => {
  const form = new FormData();
  form.append('paginacao', JSON.parse('-1'));
  form.append('pagina', JSON.parse('1'));
  form.append('ordenacaoCampo', 'preco');
  form.append('ordenacaoOrdem', 'asc');

  if (filtros) {
    form.append('filtros', filtros);
  }

  const response = await api.post<ListarCombosResponse>(
    '/Marketplace/ListarCombos',
    form,
  );
  return response.data.dados.lista;
};

export const recuperarCombo = async (termoBusca: string): Promise<Combo> => {
  const form = new FormData();
  form.append('slug', termoBusca);
  const response = await api.post<RecuperarComboResponse>(
    '/Marketplace/SelecionarCombo',
    form,
  );
  return response.data.modelo;
};

export const listarCombosComProduto = async (
  produtoID: string,
): Promise<Combo[]> => {
  const form = new FormData();
  form.append('produtoID', produtoID);
  form.append('paginacao', '10');
  form.append('pagina', '1');
  form.append('ordenacaoCampo', 'dataCadastro');
  form.append('ordenacaoOrdem', 'asc');

  const response = await api.post<ListarCombosComProdutoResponse>(
    '/Marketplace/ListarCombosPorProduto',
    form,
  );

  return response.data.dados.lista;
};
